/**
 * Сборка/разбор Markdown-документа истории болезни и конвертация <b> ↔ **.
 */

const HEADER_RE = /^##\s+(.+?)\s*$/;

/** Delphi <b>…</b> → Markdown **…**. */
export function htmlBoldToMarkdown(text) {
  if (!text) return "";
  return String(text).replace(/<b>/gi, "**").replace(/<\/b>/gi, "**");
}

/** Markdown **…** → Delphi <b>…</b> (парные маркеры). */
export function markdownBoldToHtml(text) {
  if (!text) return "";
  let out = "";
  let open = false;
  const s = String(text);
  for (let i = 0; i < s.length; i += 1) {
    if (s[i] === "*" && s[i + 1] === "*") {
      out += open ? "</b>" : "<b>";
      open = !open;
      i += 1;
    } else {
      out += s[i];
    }
  }
  if (open) out += "</b>";
  return out;
}

/**
 * @param {{ idPart: number, name: string, value?: string }[]} sections
 * @returns {string}
 */
export function sectionsToMarkdown(sections) {
  if (!Array.isArray(sections) || sections.length === 0) return "";

  return sections
    .map((section) => {
      const name = (section?.name ?? "").trim();
      const body = htmlBoldToMarkdown(section?.value ?? "").trim();
      return body ? `## ${name}\n${body}` : `## ${name}`;
    })
    .join("\n\n");
}

/**
 * Разбор Markdown в значения разделов.
 * @param {string} markdown
 * @param {{ idPart: number, name: string }[]} catalog
 * @returns {{ ok: true, sections: { idPart: number, value: string }[] } | { ok: false, error: string, unknownHeaders?: string[], missingHeaders?: string[] }}
 */
export function markdownToSections(markdown, catalog) {
  const list = Array.isArray(catalog) ? catalog : [];
  const byName = new Map(list.map((s) => [normalizeHeader(s.name), s]));

  const lines = String(markdown ?? "").replace(/\r\n/g, "\n").replace(/\r/g, "\n").split("\n");
  const found = new Map(); // idPart -> body lines
  const unknownHeaders = [];
  let currentId = null;
  let currentLines = [];

  const flush = () => {
    if (currentId == null) return;
    found.set(currentId, currentLines.join("\n").trim());
    currentId = null;
    currentLines = [];
  };

  for (const line of lines) {
    const match = HEADER_RE.exec(line);
    if (match) {
      flush();
      const header = normalizeHeader(match[1]);
      const section = byName.get(header);
      if (!section) {
        unknownHeaders.push(match[1].trim());
        currentId = null;
        currentLines = [];
      } else {
        currentId = section.idPart;
        currentLines = [];
      }
      continue;
    }
    if (currentId != null) currentLines.push(line);
  }
  flush();

  if (unknownHeaders.length > 0) {
    return {
      ok: false,
      error: `Неизвестные заголовки разделов: ${unknownHeaders.join(", ")}`,
      unknownHeaders
    };
  }

  const catalogNames = list.map((s) => normalizeHeader(s.name));
  const foundNames = new Set(
    [...found.keys()].map((id) => {
      const sec = list.find((s) => s.idPart === id);
      return normalizeHeader(sec?.name);
    })
  );
  const missingHeaders = catalogNames.filter((name) => name && !foundNames.has(name));
  if (missingHeaders.length > 0) {
    const missingLabels = missingHeaders.map((n) => {
      const sec = list.find((s) => normalizeHeader(s.name) === n);
      return sec?.name ?? n;
    });
    return {
      ok: false,
      error: `Отсутствуют разделы: ${missingLabels.join(", ")}`,
      missingHeaders: missingLabels
    };
  }

  const sections = list.map((s) => ({
    idPart: s.idPart,
    value: markdownBoldToHtml(found.get(s.idPart) ?? "")
  }));

  return { ok: true, sections };
}

function normalizeHeader(name) {
  return String(name ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
}
